function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import Decimal from "decimal.js";
import { CURRENCY, LOCALE, PLACEHOLDER } from "./consts/strings";
import { parseNumber } from "./parseNumber";
var formatNumber = function(dividend, divisor) {
    return Number(new Decimal(dividend / divisor).toFixed(2).toString());
};
/**
 * https://git.io/v7PD5 - bostock copypasta
 * number conversion and back to string strips insignificant trailing zeroes
 */ var formatBillion = function(x) {
    return formatNumber(x, 1e9) + 'B';
};
var formatMillion = function(x) {
    return formatNumber(x, 1e6) + 'MM';
};
var formatThousand = function(x) {
    return formatNumber(x, 1e3) + 'k';
};
function abbreviateValue(x) {
    var value = Math.abs(x);
    if (value >= 0.9995e9) return formatBillion(value);
    if (value >= 0.9995e6) return formatMillion(value);
    return formatThousand(value);
}
export function formatCurrency(value, options) {
    var opts = _object_spread({
        abbreviate: false,
        currency: CURRENCY,
        currencySymbol: true,
        negativeNotation: 'minus',
        positiveNotation: 'none',
        showPlaceholder: true,
        showZero: false,
        stripTrailingZeros: true,
        style: 'currency'
    }, options);
    if (value === null || value === undefined) {
        return value;
    }
    var amount = parseNumber(value);
    if (amount === 0 && opts.showPlaceholder && !opts.showZero) {
        return PLACEHOLDER;
    }
    if (typeof amount !== 'number') {
        return amount;
    }
    var currency = Number(amount).toLocaleString(LOCALE, {
        currency: opts.currency,
        currencyDisplay: opts.currencyDisplay,
        currencySign: opts.currencySign,
        localeMatcher: opts.localeMatcher,
        maximumFractionDigits: opts.maximumFractionDigits,
        maximumSignificantDigits: opts.maximumSignificantDigits,
        minimumFractionDigits: opts.minimumFractionDigits,
        minimumIntegerDigits: opts.minimumIntegerDigits,
        minimumSignificantDigits: opts.minimumSignificantDigits,
        style: opts.style,
        useGrouping: opts.useGrouping
    });
    if (opts.abbreviate && amount > 0) {
        currency = '$' + abbreviateValue(amount);
    } else if (opts.abbreviate) {
        currency = '-$' + abbreviateValue(amount);
    }
    if (amount >= 0 && opts.positiveNotation === 'plus') {
        currency = "+".concat(currency);
    }
    if (amount < 0 && opts.negativeNotation === 'parenthetical') {
        currency = currency.replace('-$', '($').concat(')');
    } else if (amount < 0 && opts.negativeNotation === 'minus') {
        currency = "-".concat(currency.replace('-', ''));
    } else if (amount < 0 && opts.negativeNotation === 'disabled') {
        currency = "".concat(currency.replace('-', ''));
    }
    if (!opts.currencySymbol) currency = currency.replace('$', '');
    if (currency.includes('.00') && opts.stripTrailingZeros) {
        return currency.replace('.00', '');
    }
    return currency;
}

//# sourceMappingURL=formatCurrency.js.map